export default {
    state: {
        UserData: [],
        loginData: [],
        emailUser: "",
    }
}